export default __webpack_public_path__ + "ec5482a4f550c92e6cbc78a1203ceeea.svg";